import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/waterMeter/selectList',
    method: 'get',
    params: data,
  });
}

export function save(data) {
  return request({
    url: '/waterMeter',
    method: 'post',
    data: data,
  });
}

export function detail(data) {
  return request({
    url: '/waterMeter',
    method: 'get',
    params: data,
  });
}

export function remove(param) {
  return request({
    url: '/waterMeter/' + param,
    method: 'delete',
  });
}

// 电表批量保存
export function waterBatchAdd(data) {
  return request({
    url: '/waterMeter/waterBatchAdd',
    method: 'post',
    data: data,
  });
}

// 获取路径
export function getPath(data) {
  return request({
    url: '/basicExcelTemplate/getPath',
    method: 'get',
    params: data,
  });
}

// 模板下载
export function load(data) {
  return request({
    url: '/file/load',
    method: 'get',
    params: data,
    responseType: 'arraybuffer',
  });
}
